import { Record } from 'immutable';

const HomeworkRecord = Record({
  sessionId: undefined,
  homeworkResultStatus: undefined,
});

class Homework extends HomeworkRecord { }

export default Homework;



// WEBPACK FOOTER //
// ./data/Homework/model.js